import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { FlowSteps } from '../FlowSteps';
import { valueFeatures } from '../../data/salesContent';
export function ValueSection() {
  return <PageSection labelledBy="value-title" className="bg-carbon-900" data-id="element-197" data-mp="27pgj2wsd5dqi">
      <SectionHeading id="value-title" title="Esto no es simplemente otro pack de ebooks sobre construcción" subtitle={<p className="font-display text-xl font-bold uppercase tracking-wide text-accent-400 md:text-2xl" data-id="element-199" data-mp="2hg2q42m0kvxl">Es un sistema completo listo para consultar y enseñar.</p>} data-id="element-198" data-mp="2ci15vecuqqkj" />
      <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-200" data-mp="2qhsipbrmu0wy">
        {valueFeatures.map(({
        icon: Icon,
        ...f
      }) => <li key={f.title} className="flex flex-col rounded-xl border border-carbon-800 bg-carbon-950 p-6" data-id="element-201" data-mp="2vfkjywe62zdt">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500/10 text-accent-400" data-id="element-202" data-mp="w4t6ztqdhquy">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="112uq2enstq6f" />
            </span>
            <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-white md:text-2xl" data-id="element-204" data-mp="i85728jzxp1z">{f.title}</h3>
            {f.body && <p className="mt-2 text-base leading-relaxed text-carbon-300" data-id="element-205" data-mp="dek565fa8axi">{f.body}</p>}
            {f.flow && <>
                <p className="mt-3 text-sm font-semibold text-carbon-200" data-id="element-206" data-mp="8f7mlwvg1q0q">{f.flowLead}</p>
                <FlowSteps steps={f.flow} align="start" className="mt-2 !text-sm md:!text-base" data-id="element-207" data-mp="4dvtvih9woob" />
              </>}
            {f.list && <>
                <p className="mt-3 text-sm font-semibold text-carbon-200" data-id="element-208" data-mp="w6wghhnwymjs">{f.listLead}</p>
                <ul className="mt-2 space-y-1" data-id="element-209" data-mp="s51gcghpyf7l">
                  {f.list.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-relaxed text-carbon-300 md:text-base" data-id="element-210" data-mp="s7dyoure2rl6">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-accent-500" aria-hidden="true" data-id="element-211" data-mp="3cwbe1lvdjvib" />
                      {item}
                    </li>)}
                </ul>
              </>}
          </li>)}
      </ul>
    </PageSection>;
}